// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-drag-marker {
  cursor: grab;
}
.grid-drag-marker:active {
  cursor: grabbing;
}

.grid-drag-tooltip {
  background: #168884;
  color: #fff;
  border: none;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  box-shadow: none;
}
.grid-drag-tooltip::before {
  border-top-color: #168884;
}

.grid-manager-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.grid-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 12px;
  background: #168884;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.grid-manager-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  overflow: hidden;
}

.grid-manager-layout {
  display: flex;
  gap: 20px;
  flex: 1 1 auto;
  min-height: 0;
}

.grid-manager-map {
  position: relative;
  flex: 75 1 0%;
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.grid-placement-banner {
  position: absolute;
  z-index: 1001;
  top: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #168884;
  border-radius: 6px;
  padding: 8px 12px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  color: #2d3748;
}
.grid-placement-banner kbd {
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 12px;
  color: #4a5568;
}

.grid-form-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 13px;
  color: #2d3748;
  padding: 4px;
}
.grid-form-panel label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #718096;
  margin-bottom: 4px;
}

.grid-form-fields {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  gap: 14px;
}

.grid-form-title {
  font-size: 16px;
  font-weight: 700;
  color: #2d3748;
}

.grid-form-row {
  display: flex;
  gap: 10px;
}
.grid-form-row .grid-form-field {
  flex: 1 1 0;
}

.grid-form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}
.grid-form-footer .btn {
  min-width: 84px;
  border-radius: 6px;
  font-weight: 600;
}

.grid-devices-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.grid-devices-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.grid-devices-title {
  font-size: 12px;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.grid-devices-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #edf2f7;
  color: #4a5568;
  font-size: 11px;
  font-weight: 700;
}

.grid-devices-search {
  position: relative;
  margin-bottom: 10px;
  flex: 0 0 auto;
}
.grid-devices-search .grid-devices-search-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 11px;
  pointer-events: none;
}
.grid-devices-search input {
  padding-left: 28px;
  padding-right: 26px;
}
.grid-devices-search .grid-devices-search-clear {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #a0aec0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}
.grid-devices-search .grid-devices-search-clear:hover {
  color: #718096;
}

.grid-devices-list {
  flex: 1 1 auto;
  min-height: 60px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.grid-devices-list,
.grid-manager-sidebar {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 transparent;
}
.grid-devices-list::-webkit-scrollbar,
.grid-manager-sidebar::-webkit-scrollbar {
  width: 6px;
}
.grid-devices-list::-webkit-scrollbar-track,
.grid-manager-sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.grid-devices-list::-webkit-scrollbar-thumb,
.grid-manager-sidebar::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 3px;
}
.grid-devices-list::-webkit-scrollbar-thumb:hover,
.grid-manager-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #a0aec0;
}

.grid-devices-loading,
.grid-devices-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 8px;
  text-align: center;
  font-size: 12px;
}

.grid-devices-error {
  color: #c53030;
}

.grid-device-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}
.grid-device-row:hover {
  border-color: #168884;
}

.grid-device-status-dot {
  flex: 0 0 auto;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.grid-device-status-dot.grid-device-status-active {
  background: #38a169;
  box-shadow: 0 0 0 3px rgba(56, 161, 105, 0.15);
}
.grid-device-status-dot.grid-device-status-inactive {
  background: #e53e3e;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.12);
}

.grid-device-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.grid-device-name {
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.grid-device-hover-popup {
  position: fixed;
  z-index: 2000;
  width: 200px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  padding: 8px 12px;
  pointer-events: none;
}

.grid-device-hover-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
}
.grid-device-hover-row:last-child {
  border-bottom: none;
}

.grid-device-hover-label {
  color: #718096;
  font-weight: 600;
}

.grid-device-hover-value {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2d3748;
  font-weight: 600;
  text-align: right;
}

.grid-device-serial {
  font-size: 11px;
  color: #a0aec0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.grid-devices-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 0 0 auto;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e2e8f0;
}
.grid-devices-pagination .grid-icon-btn {
  width: 24px;
  height: 24px;
}
.grid-devices-pagination .grid-icon-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.grid-devices-pagination .grid-icon-btn:disabled:hover {
  background: none;
  color: #168884;
}

.grid-devices-page-label {
  font-size: 11px;
  color: #718096;
  font-weight: 600;
}

.grid-manager-sidebar {
  flex: 25 1 0%;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 12px;
}

.grid-empty-state {
  padding: 20px 10px;
  text-align: center;
}

.grid-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
  cursor: pointer;
}
.grid-card:hover {
  border-color: #168884;
}
.grid-card.grid-card-active {
  border-color: #168884;
  background: #f5fafc;
}

.grid-card-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d3748;
}

.grid-card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #718096;
  margin-top: 2px;
}

.grid-size-badge {
  background: #edf2f7;
  color: #4a5568;
  border-radius: 4px;
  padding: 1px 6px;
  font-weight: 600;
}

.grid-card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.grid-icon-btn {
  background: none;
  border: none;
  color: #168884;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.grid-icon-btn:hover {
  background: #edf2f7;
  color: #157188;
}
.grid-icon-btn.grid-icon-btn-danger {
  background: none;
  border: none;
  color: #718096;
}
.grid-icon-btn.grid-icon-btn-danger:hover {
  background: #f7fafc;
  color: #4a5568;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/entities/grid-management/grid-manager.scss"],"names":[],"mappings":"AAIA;EACE,YAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;;AAOA;EACE,mBAbc;EAcd,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAME;EACE,yBAvBY;AAmBhB;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBA1Cc;EA2Cd,WAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0CAAA;EACA,eAAA;EACA,cAAA;AALF;AAOE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AANF;AAQE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AANJ;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,SAAA;AAPF;AASE;EACE,WAAA;AAPJ;;AAWA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AARF;AAUE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AATF;AAWE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AATJ;AAYE;EACE,kBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAXJ;AAaI;EACE,cAAA;AAXN;;AAgBA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAbF;;AAgBA;;EAEE,qBAAA;EACA,oCAAA;AAbF;AAeE;;EACE,UAAA;AAZJ;AAeE;;EACE,uBAAA;AAZJ;AAeE;;EACE,yBAAA;EACA,kBAAA;AAZJ;AAeE;;EACE,yBAAA;AAZJ;;AAgBA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAbF;AAeE;EACE,qBA7RY;AAgRhB;;AAiBA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAdF;AAgBE;EACE,mBAAA;EACA,8CAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,6CAAA;AAfJ;;AAmBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;EACA,oBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AAhBF;AAkBE;EACE,mBAAA;AAhBJ;;AAoBA;EACE,cAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAjBF;AAmBE;EACE,WAAA;EACA,YAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,eAAA;AAjBN;AAmBM;EACE,gBAAA;EACA,cArYQ;AAoXhB;;AAuBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AApBF;AAsBE;EACE,qBA7aY;AAyZhB;AAuBE;EACE,qBAjbY;EAkbZ,mBAAA;AArBJ;;AAyBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,YAAA;EACA,cAtdc;EAudd,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAtBF;AAwBE;EACE,mBAAA;EACA,cA/dU;AAycd;AAyBE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AAvBJ;AAyBI;EACE,mBAAA;EACA,cAAA;AAvBN","sourcesContent":["$color-primary: #168884;\n$hover-color: #157188;\n$border-color: #e2e8f0;\n\n.grid-drag-marker {\n  cursor: grab;\n\n  &:active {\n    cursor: grabbing;\n  }\n}\n\n.grid-drag-tooltip {\n  background: $color-primary;\n  color: #fff;\n  border: none;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  box-shadow: none;\n\n  &::before {\n    border-top-color: $color-primary;\n  }\n}\n\n.grid-manager-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.grid-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 6px;\n  border-radius: 12px;\n  background: $color-primary;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.grid-manager-card {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 100px);\n  overflow: hidden;\n}\n\n.grid-manager-layout {\n  display: flex;\n  gap: 20px;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.grid-manager-map {\n  position: relative;\n  flex: 75 1 0%;\n  min-width: 0;\n  border: 1px solid $border-color;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.grid-placement-banner {\n  position: absolute;\n  z-index: 1001;\n  top: 12px;\n  left: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  border: 1px solid $color-primary;\n  border-radius: 6px;\n  padding: 8px 12px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n  color: #2d3748;\n\n  kbd {\n    background: #edf2f7;\n    border: 1px solid $border-color;\n    border-radius: 4px;\n    padding: 1px 6px;\n    font-size: 12px;\n    color: #4a5568;\n  }\n}\n\n.grid-form-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  font-size: 13px;\n  color: #2d3748;\n  padding: 4px;\n\n  label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #718096;\n    margin-bottom: 4px;\n  }\n}\n\n.grid-form-fields {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 auto;\n  gap: 14px;\n}\n\n.grid-form-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2d3748;\n}\n\n.grid-form-row {\n  display: flex;\n  gap: 10px;\n\n  .grid-form-field {\n    flex: 1 1 0;\n  }\n}\n\n.grid-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 14px;\n  border-top: 1px solid $border-color;\n\n  .btn {\n    min-width: 84px;\n    border-radius: 6px;\n    font-weight: 600;\n  }\n}\n\n.grid-devices-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid $border-color;\n}\n\n.grid-devices-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.grid-devices-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #718096;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.grid-devices-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  background: #edf2f7;\n  color: #4a5568;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.grid-devices-search {\n  position: relative;\n  margin-bottom: 10px;\n  flex: 0 0 auto;\n\n  .grid-devices-search-icon {\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    transform: translateY(-50%);\n    color: #a0aec0;\n    font-size: 11px;\n    pointer-events: none;\n  }\n\n  input {\n    padding-left: 28px;\n    padding-right: 26px;\n  }\n\n  .grid-devices-search-clear {\n    position: absolute;\n    top: 50%;\n    right: 6px;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #a0aec0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n\n    &:hover {\n      color: #718096;\n    }\n  }\n}\n\n.grid-devices-list {\n  flex: 1 1 auto;\n  min-height: 60px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.grid-devices-list,\n.grid-manager-sidebar {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e0 transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #cbd5e0;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #a0aec0;\n  }\n}\n\n.grid-devices-loading,\n.grid-devices-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 8px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.grid-devices-error {\n  color: #c53030;\n}\n\n.grid-device-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border: 1px solid $border-color;\n  border-radius: 6px;\n\n  &:hover {\n    border-color: $color-primary;\n  }\n}\n\n.grid-device-status-dot {\n  flex: 0 0 auto;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n\n  &.grid-device-status-active {\n    background: #38a169;\n    box-shadow: 0 0 0 3px rgba(56, 161, 105, 0.15);\n  }\n\n  &.grid-device-status-inactive {\n    background: #e53e3e;\n    box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.12);\n  }\n}\n\n.grid-device-info {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.grid-device-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2d3748;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.grid-device-hover-popup {\n  position: fixed;\n  z-index: 2000;\n  width: 200px;\n  background: #fff;\n  border: 1px solid $border-color;\n  border-radius: 6px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n  padding: 8px 12px;\n  pointer-events: none;\n}\n\n.grid-device-hover-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 6px 0;\n  border-bottom: 1px solid $border-color;\n  font-size: 12px;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.grid-device-hover-label {\n  color: #718096;\n  font-weight: 600;\n}\n\n.grid-device-hover-value {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #2d3748;\n  font-weight: 600;\n  text-align: right;\n}\n\n.grid-device-serial {\n  font-size: 11px;\n  color: #a0aec0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.grid-devices-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex: 0 0 auto;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid $border-color;\n\n  .grid-icon-btn {\n    width: 24px;\n    height: 24px;\n\n    &:disabled {\n      opacity: 0.35;\n      cursor: default;\n\n      &:hover {\n        background: none;\n        color: $color-primary;\n      }\n    }\n  }\n}\n\n.grid-devices-page-label {\n  font-size: 11px;\n  color: #718096;\n  font-weight: 600;\n}\n\n.grid-manager-sidebar {\n  flex: 25 1 0%;\n  min-width: 280px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n  border: 1px solid $border-color;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.grid-empty-state {\n  padding: 20px 10px;\n  text-align: center;\n}\n\n.grid-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 1px solid $border-color;\n  border-radius: 6px;\n  padding: 10px 12px;\n  cursor: pointer;\n\n  &:hover {\n    border-color: $color-primary;\n  }\n\n  &.grid-card-active {\n    border-color: $color-primary;\n    background: #f5fafc;\n  }\n}\n\n.grid-card-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: #2d3748;\n}\n\n.grid-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #718096;\n  margin-top: 2px;\n}\n\n.grid-size-badge {\n  background: #edf2f7;\n  color: #4a5568;\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-weight: 600;\n}\n\n.grid-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.grid-icon-btn {\n  background: none;\n  border: none;\n  color: $color-primary;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: #edf2f7;\n    color: $hover-color;\n  }\n\n  &.grid-icon-btn-danger {\n    background: none;\n    border: none;\n    color: #718096;\n\n    &:hover {\n      background: #f7fafc;\n      color: #4a5568;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
